import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import MyCoachAvailability from "../../components/MyCoachAvailability/MyCoachAvailability";
import { theme as themeConfig } from "../../themes/themes";
import {
  HR,
  GeneralAvailabilityMyCoach,
} from "./MyCoachAvailabilityContainer.styled";
import { useLazyQuery, useMutation } from "@apollo/client";
import { COACH_AVAILABILITY } from "../../GraphQL/Queries";
import { NotificationManager } from "react-notifications";
import { Col, Row } from "react-bootstrap";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import {
  ADD_NEW_EVENT,
  PARTICIPANT_ATTEND_CHANGE,
} from "../../GraphQL/Mutations";
import { clientWellness } from "../../App";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import ModalDetailMyCoach from "../../components/ModalDetailMyCoach/ModalDetailMyCoach";
import BackButtonComponent from "../../components/BackButtonComponent/BackButtonComponent";
import moment from "moment";

const MyCoachAvailabilityContainer = () => {
  const history = useHistory();
  const location = useLocation();
  const [coach] = useState(location.state.coach);
  const [coachAvailable, setCoachAvailable] = useState();
  const [valueOfCalendar, setValueOfCalendar] = useState(new Date());
  const [eventId, setEventId] = useState(null);
  const [openReadMoreModal, setOpenReadMoreModal] = useState(null);
  const [addNewEvent] = useMutation(ADD_NEW_EVENT, {
    client: clientWellness,
  });
  const [user] = useState(getStateLoginComplete());
  const [userData, setUserData] = useState({});
  const [participantAttendChange] = useMutation(PARTICIPANT_ATTEND_CHANGE, {
    client: clientWellness,
  });

  const [
    runQueryCoachAvailability,
    { loading: loadingCoachAvailable, error: errorCoachAvailable },
  ] = useLazyQuery(COACH_AVAILABILITY, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data.coachAvailability !== null && data.coachAvailability) {
        setCoachAvailable(data.coachAvailability);
      } else {
        NotificationManager.error(
          "Something is wrong with the data of the coach availability",
          "",
          5000
        );
      }
    },
  });

  useEffect(() => {
    if (coach) {
      setUserData(user);
    }
  }, [coach]);

  useEffect(() => {
    if (coach) {
      let dayOfToday = new Date();
      let calendarValue = new Date(valueOfCalendar);
      dayOfToday.setHours(0, 0, 0, 0);
      calendarValue.setHours(0, 0, 0, 0);
      if (calendarValue >= dayOfToday) {
        runQueryCoachAvailability({
          variables: {
            coachId: coach.idCoach,
            startDate: calendarValue > dayOfToday ? moment(valueOfCalendar).format() : moment().format(),
            finishDate: moment(valueOfCalendar).endOf("day").format(),
          },
        }).catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager(errorMessage, "", 5000);
        });
      } else {
        NotificationManager.info(
          "The finish date need to be the same or after the day of today",
          "",
          5000
        );
      }
    }
  }, [coach, runQueryCoachAvailability, valueOfCalendar, setValueOfCalendar]);

  useEffect(() => {
    if (eventId) {
      NotificationManager.success("Event created", "", 5000);
      goToBackPage();
    }
  }, [eventId]);

  let goToBackPage = () => {
    history.push({
      pathname: `/MyCoaches`,
    });
  };

  let requestAvailability = (item) => {
    if (
      item.cityId &&
      item.countryId &&
      item.eventCategoryId &&
      item.eventDescription &&
      item.eventName &&
      item.eventStatus &&
      item.eventType &&
      item.languageId &&
      item.startDate &&
      item.finishDate &&
      item.participantIsRequired
    ) {
      let startDate = new Date(item.startDate).toISOString();
      let finishDate = new Date(item.finishDate).toISOString();
      addNewEvent({
        variables: {
          cityId: item.cityId,
          countryId: item.countryId,
          eventCategoryId: item.eventCategoryId,
          eventDescription: item.eventDescription,
          eventName: item.eventName,
          eventStatus: item.eventStatus,
          eventType: item.eventType,
          eventUri: item.eventUri,
          groups: item.groups,
          individualGuests: item.individualGuests,
          languageId: item.languageId,
          participantIsRequired: item.participantIsRequired,
          participantsLimit: item.participantsLimit,
          photoUri: item.photoUri,
          speakers: item.speakers,
          startDate: startDate,
          finishDate: finishDate,
        },
      })
        .then((response) => {
          if (response.errors) {
            NotificationManager.error(response.errors[0].message, "", 5000);
          } else {
            if (response.data.addNewEvent.idEvent) {
              setEventId(response.data.addNewEvent.idEvent);
              saveAccept(
                response.data.addNewEvent.idEvent,
                item.individualGuests
              );
            }
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.warning("Missing fields", "", 5000);
    }
  };

  const showReadMoreModal = () => {
    return openReadMoreModal ? (
      <ModalDetailMyCoach
        openReadMoreModal={openReadMoreModal}
        setOpenReadMoreModal={setOpenReadMoreModal}
      />
    ) : null;
  };

  const handleSeeDetail = () => {
    setOpenReadMoreModal(coach);
  };

  const saveAccept = (idEvent, userIds) => {
    participantAttendChange({
      variables: {
        eventId: idEvent,
        userId: userIds[0],
        participantAttend: "Accept",
        userChange: user.userName + "@nlsa.teleperformance.com",
      },
    }).catch((error) => {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    });
    participantAttendChange({
      variables: {
        eventId: idEvent,
        userId: userIds[1],
        participantAttend: "Accept",
        userChange: user.userName + "@nlsa.teleperformance.com",
      },
    }).catch((error) => {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    });
  };

  return (
    <GeneralAvailabilityMyCoach>
      <BackButtonComponent
        backtitle={"Coaches"}
        locationtitle={coach?.firstName}
        goToBackPage={goToBackPage}
        identity={"isMyCoaches"}
      />
      <HR />
      {loadingCoachAvailable && !errorCoachAvailable && (
        <Row>
          <Col
            md="12"
            className="d-flex justify-content-center align-content-center my-5"
          >
            <PointersLine color={themeConfig.text.primary} />
          </Col>
        </Row>
      )}
      {!loadingCoachAvailable && errorCoachAvailable && (
        <Row>
          <Col
            md="12"
            className="d-flex justify-content-center align-content-center my-5"
          >
            <h1 style={{ color: themeConfig.neutral.gray[900] }}>Error :(</h1>
          </Col>
        </Row>
      )}
      {!loadingCoachAvailable && !errorCoachAvailable && (
        <MyCoachAvailability
          userData={userData}
          coachAvailable={coachAvailable}
          valueOfCalendar={valueOfCalendar}
          setValueOfCalendar={setValueOfCalendar}
          handleCancel={goToBackPage}
          requestAvailability={requestAvailability}
          handleSeeDetail={handleSeeDetail}
        />
      )}
      {showReadMoreModal()}
    </GeneralAvailabilityMyCoach>
  );
};

export default MyCoachAvailabilityContainer;
